import { Provider } from '@angular/core';

import { ApplicationSubmodulesFacade } from './application-submodules.facade';
import { provideSubmodule, SubmoduleConfig } from './current-submodule/application-current-submodule.provider';
import { provideSubmodules, SubmodulesConfig } from './submodules/application-submodules.provider';

type ApplicationSubmodulesConfig = SubmodulesConfig & SubmoduleConfig;

export function provideApplicationSubmodules(config: ApplicationSubmodulesConfig): Provider[] {
  return [provideSubmodules(config), provideSubmodule(config), ApplicationSubmodulesFacade];
}
